import { NMNResult } from "..";
import { LanguageArray } from "../i18n";
import { addMusicProp, addRenderProp, ScoreContext, scoreContextDefault } from "../parser/sparse2des/context";
import { HeaderRenderer } from "./header/HeaderRenderer";
import { ArticleRenderer } from "./article/ArticleRenderer";
import { EquifieldSection } from "../equifield/equifield";
import { MusicSection, NoteCharMusic } from "../parser/sparse2des/types";

export type RenderContext = ScoreContext & {
	language: LanguageArray
	positionCallback: RenderPositionCallback | undefined
	sectionPickCallback: RenderSectionPickCallback | undefined
	articleOrdinal: number
}
export type RenderPositionCallback = (lineNumber: number, charPos: number) => void
export type RenderSectionPickCallback = (articleOrdinal: number, section: MusicSection<NoteCharMusic>) => void

class RendererClass {
	render(
		score: NMNResult['result'],
		lng: LanguageArray,
		positionCallback: RenderPositionCallback | undefined,
		sectionPickCallback: RenderSectionPickCallback | undefined,
		lineWidth?: number,
		pageMarginX?: [number, number],
	): EquifieldSection[] {
		let sections: EquifieldSection[] = []
		const context: RenderContext = {
			language: lng,
			positionCallback: positionCallback,
			sectionPickCallback: sectionPickCallback,
			...addMusicProp(addRenderProp(
				scoreContextDefault, score.renderProps?.props
			), score.musicalProps?.props),
			articleOrdinal: NaN
		}
		// 手机「一行一小节」浏览模式覆盖每行纸面宽度（默认 100em），放大音符、贴满屏宽。
		// 用展开重建 render 对象，避免污染模块级单例 renderPropsDefault。
		if(lineWidth !== undefined) {
			context.render = { ...context.render, line_width: lineWidth }
		}

		// ==== 头部信息 ====
		HeaderRenderer.renderTop(score, sections, context)
		HeaderRenderer.renderPropsAndAuthors(score, sections, context)
		HeaderRenderer.renderTopSpacer(score, sections, context)
		// ==== 章节 ====
		let context1 = context
		score.articles.forEach((article, articleOrdinal) => {
			let contextPre = addRenderProp(context1, article.renderProps?.props)
			if(article.type == 'music') {
				contextPre = addMusicProp(contextPre, article.musicalProps?.props)
			}
			const context = {
				...context1,
				...contextPre,
				articleOrdinal: articleOrdinal,
			}
			ArticleRenderer.renderArticle(article, sections, context)
		})
		// ==== 尾注 ====
		HeaderRenderer.renderFooter(score, sections, context)

		// ==== 移除末尾空白 ====
		while(sections.length > 0 && sections[sections.length - 1].isMargin) {
			sections.pop()
		}

		// ==== 添加页面边距 ====
		sections.forEach(section => {
			// 手机「一行一小节」浏览模式可覆盖左右留白（默认 [11,11]），缩小留白让谱面更宽。
			section.padding = pageMarginX ?? context.render.page_margin_x!
			// 每行纸面宽度随 section 下发，供 Equifield 反推字号（64/(lineWidth+padding)）
			section.lineWidth = context.render.line_width!
		})

		return sections
	}
}

export const Renderer = new RendererClass()
